"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _A11yWrapper = _interopRequireDefault(require("../A11yWrapper/A11yWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The FilterDropdown component
 */
var FilterDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterDropdown, _React$Component);

  var _super = _createSuper(FilterDropdown);

  function FilterDropdown(props) {
    var _this;

    _classCallCheck(this, FilterDropdown);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      values: {}
    };
    _this.handleFilterToggleClick = _this.handleFilterToggleClick.bind(_assertThisInitialized(_this));
    _this.handleApplyFilters = _this.handleApplyFilters.bind(_assertThisInitialized(_this));
    _this.handleClearFilters = _this.handleClearFilters.bind(_assertThisInitialized(_this));
    _this.openPanel = _this.openPanel.bind(_assertThisInitialized(_this));
    _this.closePanel = _this.closePanel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterDropdown, [{
    key: "handleFilterToggleClick",
    value: function handleFilterToggleClick(e) {
      e.preventDefault();

      if (!this.state.isOpen) {
        this.openPanel();
      } else {
        this.closePanel();
      }
    }
  }, {
    key: "openPanel",
    value: function openPanel() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "closePanel",
    value: function closePanel() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "handleClearFilters",
    value: function handleClearFilters(e) {
      e.preventDefault();
      this.setState({
        values: {},
        isOpen: false
      });
      this.props.onClearFilters();
    }
  }, {
    key: "handleApplyFilters",
    value: function handleApplyFilters(e) {
      e.preventDefault();
      this.setState({
        isOpen: false
      });
      this.props.onApplyFilters(this.state.values);
    }
  }, {
    key: "handleFilterChange",
    value: function handleFilterChange(id, value) {
      this.setState(function (prevState) {
        return {
          values: _objectSpread(_objectSpread({}, prevState.values), {}, _defineProperty({}, "".concat(id), value))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          toggleLabel = _this$props.toggleLabel;
      var classes = (0, _classnames.default)('filter-dropdown', {
        'is-open': this.state.isOpen
      });
      var panelId = "filter-panel__".concat(id);
      return /*#__PURE__*/_react.default.createElement(_A11yWrapper.default, {
        className: classes,
        isActive: this.state.isOpen,
        exitOnEscape: true,
        exitOnClickOutside: true,
        onExit: this.closePanel
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "fd__toggle",
        href: "#".concat(panelId),
        "aria-expanded": this.state.isOpen,
        onClick: this.handleFilterToggleClick
      }, toggleLabel, /*#__PURE__*/_react.default.createElement("span", {
        className: "icon"
      })), /*#__PURE__*/_react.default.createElement("div", {
        id: panelId,
        className: "fd__panel"
      }, this.props.children));
    }
  }]);

  return FilterDropdown;
}(_react.default.Component);

FilterDropdown.defaultProps = {
  onApplyFilters: function onApplyFilters() {},
  onClearFilters: function onClearFilters() {},
  toggleLabel: 'Filter results',
  children: null
};
FilterDropdown.propTypes = {
  id: _propTypes.default.string.isRequired,
  onApplyFilters: _propTypes.default.func,
  onClearFilters: _propTypes.default.func,
  toggleLabel: _propTypes.default.string,
  children: _propTypes.default.node
};
var _default = FilterDropdown;
exports.default = _default;
//# sourceMappingURL=FilterDropdown.js.map